var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "job-content-table",
    { attrs: { title: "志向の指定" } },
    _vm._l(_vm.matching.workStyleList, function (workStyle, i) {
      return _c(
        "job-content-table-outline",
        _vm._g(
          {
            key: "work-style-" + i,
            attrs: {
              title: workStyle.name,
              "target-id": _vm.targetIdMap.matching.workStyle.list[i],
              value: _vm.createJoinedText(workStyle.labelList),
              "comment-highlights": _vm.getCommentHighlights(
                _vm.targetIdMap.matching.workStyle.list[i]
              ),
              "highlight-mode": _vm.highlightMode,
            },
          },
          _vm.$listeners
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }